/**
 * Created by contrapro on 03/04/2018
 */

//------------ error
export const ACTION_TYPE_EPIC_CATCH_ERROR = 'ACTION_TYPE_EPIC_CATCH_ERROR';
export const epicCatchError = (error, from) => (
    {
        type: ACTION_TYPE_EPIC_CATCH_ERROR,
        payload: {
            error:error,
            from:from
        }
    }
);

//------------ redirect
export const ACTION_TYPE_REDIRECT_TO = 'ACTION_TYPE_REDIRECT_TO';
export const redirectTo = (url) => (
    {
        type: ACTION_TYPE_REDIRECT_TO,
        payload: {
            url:url
        }
    }
);

//------------ 加载系统消息
export const ACTION_TYPE_LOAD_MESSAGE = 'ACTION_TYPE_LOAD_MESSAGE';
export const loadMessage = (userObjectId) => (
    {
        type: ACTION_TYPE_LOAD_MESSAGE,
        payload: {
            userObjectId: userObjectId
        }
    }
);


export const ACTION_TYPE_MESSAGE_RESULT = 'ACTION_TYPE_LOAD_MESSAGE_RESULT';
export const messageResult = (msgs) => (
    {
        type: ACTION_TYPE_MESSAGE_RESULT,
        payload: {
            msgs: msgs
        }
    }
);



export const ACTION_TYPE_SET_MESSAGE = 'ACTION_TYPE_SET_MESSAGE';
export const setMessageRead = (msgID) => (
    {
        type: ACTION_TYPE_SET_MESSAGE,
        payload: {
            msgID: msgID
        }
    }
);

export const ACTION_TYPE_SET_MESSAGE_RESULT = 'ACTION_TYPE_SET_MESSAGE_RESULT';
export const setMessageReadResult = (res) => (
    {
        type: ACTION_TYPE_SET_MESSAGE_RESULT,
        payload: {
            res:res
        }
    }
);

export const ACTION_TYPE_MESSAGE_ERROR = 'ACTION_TYPE_MESSAGE_ERROR';
export const messageError = (error, from) => (
    {
        type: ACTION_TYPE_MESSAGE_ERROR,
        payload: {
            error:error,
            from:from
        }
    }
);


//--------- share

export const ACTION_TYPE_ON_SHARE_OK = 'ACTION_TYPE_ON_SHARE_OK';
export const onShareOK = () => (
    {
        type: ACTION_TYPE_ON_SHARE_OK,
        payload: {
        }
    }
);

export const ACTION_TYPE_ON_SHARE_CANCEL = 'ACTION_TYPE_ON_SHARE_CANCEL';
export const onShareCancel = () => (
    {
        type: ACTION_TYPE_ON_SHARE_CANCEL,
        payload: {
        }
    }
);

//----------- login

export const ACTION_TYPE_LOGIN = 'ACTION_TYPE_LOGIN';
export const ACTION_TYPE_LOGIN_RESULT = 'ACTION_TYPE_LOGIN_RESULT';
export const ACTION_TYPE_LOGIN_ERROR = 'ACTION_TYPE_LOGIN_ERROR';

export const login = (sceneData) => (
    {
        type: ACTION_TYPE_LOGIN,
        payload: {
            sceneData:sceneData
        }
    }
);

export const loginResult = (session, extraParam) => (
    {
        type: ACTION_TYPE_LOGIN_RESULT,
        payload: {
            session: session,
            extraParam: extraParam
        }
    }
);

export const loginError = (error) => (
    {
        type: ACTION_TYPE_LOGIN_ERROR,
        payload: {
            error
        }
    }
);

//---------- updateViewState
export const ACTION_TYPE_UPDATE_VIEW_STATE = 'ACTION_TYPE_UPDATE_VIEW_STATE';
export function updateViewState(viewState) {
    return {
        type: ACTION_TYPE_UPDATE_VIEW_STATE,
        payload: {
            viewState:viewState
        }
    }
}

//---------- update share panel visible
export const ACTION_TYPE_TOGGLE_SHARE_PANEL = 'ACTION_TYPE_TOGGLE_SHARE_PANEL';
export function toggleSharePanel(visible) {
    return {
        type: ACTION_TYPE_TOGGLE_SHARE_PANEL,
        payload: {
            visible:visible
        }
    }
}


//---------- updateLocalUser
export const ACTION_TYPE_UPDATE_LOCAL_USER = 'ACTION_TYPE_UPDATE_LOCAL_USER';
export function updateLocalUser(userData) {
    return {
        type: ACTION_TYPE_UPDATE_LOCAL_USER,
        payload: {
            data:userData
        }
    }
}


//----------------- point
export const ACTION_TYPE_ADD_POINT = 'ACTION_TYPE_ADD_POINT';
export const addUserPoint = (point, remark, pointType) => (
    {
        type: ACTION_TYPE_ADD_POINT,
        payload: {
            pointType: pointType,
            point:point,
            remark:remark
        }
    }
);

export const ACTION_TYPE_POINT_RESULT = 'ACTION_TYPE_POINT_RESULT';
export const pointResult = (res) => (
    {
        type: ACTION_TYPE_POINT_RESULT,
        payload: {
            res:res
        }
    }
);

export const ACTION_TYPE_POINT_ERROR = 'ACTION_TYPE_POINT_ERROR';
export const pointError = (error, from) => (
    {
        type: ACTION_TYPE_POINT_ERROR,
        payload: {
            error:error,
            from:from
        }
    }
);

//----------------- Wish
export const ACTION_TYPE_ADD_WISH = 'ACTION_TYPE_ADD_WISH';
export const addWish = (type) => (
    {
        type: ACTION_TYPE_ADD_WISH,
        payload: {
            type: type
        }
    }
);

export const ACTION_TYPE_ADD_WISH_RESULT = 'ACTION_TYPE_ADD_WISH_RESULT';
export const addWishResult = (res) => (
    {
        type: ACTION_TYPE_ADD_WISH_RESULT,
        payload: {
            res:res
        }
    }
);

export const ACTION_TYPE_LOAD_WISHES = 'ACTION_TYPE_LOAD_WISHES';
export const loadWishes = (onlyMine) => (
    {
        type: ACTION_TYPE_LOAD_WISHES,
        payload: {
            onlyMine:onlyMine
        }
    }
);


export const ACTION_TYPE_LOAD_WISHES_RESULT = 'ACTION_TYPE_LOAD_WISHES_RESULT';
export const loadWishesResult = (onlyMine, wishes, userObjectId) => onlyMine?(
    {
        type: ACTION_TYPE_LOAD_WISHES_RESULT,
        payload: {
            onlyMine:onlyMine,
            myWishes:wishes,
            userObjectId: userObjectId
        }
    }
):({
    type: ACTION_TYPE_LOAD_WISHES_RESULT,
    payload: {
        onlyMine:onlyMine,
        allWishes:wishes,
        userObjectId: userObjectId
    }
});

export const ACTION_TYPE_POWER_WISH = 'ACTION_TYPE_POWER_WISH';
export const powerWish = (wishID, hp) => (
    {
        type: ACTION_TYPE_POWER_WISH,
        payload: {
            wishID: wishID,
            hp: hp
        }
    }
);

export const ACTION_TYPE_POWER_WISH_RESULT = 'ACTION_TYPE_POWER_WISH_RESULT';
export const powerWishResult = (res) => (
    {
        type: ACTION_TYPE_POWER_WISH_RESULT,
        payload: {
            res:res
        }
    }
);

//核销愿望
export const ACTION_TYPE_USE_WISH = 'ACTION_TYPE_USE_WISH';
export const useWish = (wishId) => (
    {
        type: ACTION_TYPE_USE_WISH,
        payload: {
            wishId: wishId,
        }
    }
);

export const ACTION_TYPE_USE_WISH_RESULT = 'ACTION_TYPE_USE_WISH_RESULT';
export const useWishResult = (res) => (
    {
        type: ACTION_TYPE_USE_WISH_RESULT,
        payload: {
            res:res
        }
    }
);

export const ACTION_TYPE_WISH_ERROR = 'ACTION_TYPE_WISH_ERROR';
export const wishError = (error, from) => (
    {
        type: ACTION_TYPE_WISH_ERROR,
        payload: {
            error:error,
            from:from
        }
    }
);



//----------------- CARD
export const ACTION_TYPE_GET_CARD = 'ACTION_TYPE_GET_CARD';
export const getCard = (cardId) => (
    {
        type: ACTION_TYPE_GET_CARD,
        payload: {
            cardId: cardId
        }
    }
);

export const ACTION_TYPE_GET_CARD_RESULT = 'ACTION_TYPE_GET_CARD_RESULT';
export const getCardResult = (res) => (
    {
        type: ACTION_TYPE_GET_CARD_RESULT,
        payload: {
            res:res
        }
    }
);

export const ACTION_TYPE_CARD_ERROR = 'ACTION_TYPE_CARD_ERROR';
export const cardError = (error, from) => (
    {
        type: ACTION_TYPE_CARD_ERROR,
        payload: {
            error:error,
            from:from
        }
    }
);

//---------------- lightLottery ------------
export const ACTION_TYPE_LIGHT_LOTTERY = 'ACTION_TYPE_LIGHT_LOTTERY';
export const lightLottery = () => (
    {
        type: ACTION_TYPE_LIGHT_LOTTERY,
        payload: {

        }
    }
);

export const ACTION_TYPE_LIGHT_LOTTERY_RESULT = 'ACTION_TYPE_LIGHT_LOTTERY_RESULT';
export const lightLotteryResult = (res) => (
    {
        type: ACTION_TYPE_LIGHT_LOTTERY_RESULT,
        payload: {
            res:res
        }
    }
);
//------ lightCollect ------------
export const ACTION_TYPE_LIGHT_COLLECT = 'ACTION_TYPE_LIGHT_COLLECT';
export const lightCollect = (type) => (
    {
        type: ACTION_TYPE_LIGHT_COLLECT,
        payload: {
            type:type
        }
    }
);

export const ACTION_TYPE_LIGHT_COLLECT_RESULT = 'ACTION_TYPE_LIGHT_COLLECT_RESULT';
export const lightCollectResult = (res) => (
    {
        type: ACTION_TYPE_LIGHT_COLLECT_RESULT,
        payload: {
            res:res
        }
    }
);

export const ACTION_TYPE_LOAD_LIGHT_COLLECT = 'ACTION_TYPE_LOAD_LIGHT_COLLECT';
export const loadLightCollect = (onlyMine) => (
    {
        type: ACTION_TYPE_LOAD_LIGHT_COLLECT,
        payload: {
            onlyMine:onlyMine
        }
    }
);


export const ACTION_TYPE_LOAD_LIGHT_COLLECT_RESULT = 'ACTION_TYPE_LOAD_LIGHT_COLLECT_RESULT';
export const loadLightCollectResult = (onlyMine, lights) => onlyMine?(
    {
        type: ACTION_TYPE_LOAD_LIGHT_COLLECT_RESULT,
        payload: {
            onlyMine:onlyMine,
            myLights:lights
        }
    }
):({
    type: ACTION_TYPE_LOAD_LIGHT_COLLECT_RESULT,
    payload: {
        onlyMine:onlyMine,
        allLights:lights
    }
});

//------ light QA
export const ACTION_TYPE_ADD_LIGHT_QA = 'ACTION_TYPE_ADD_LIGHT_QA';
export const addLightQA = (answers) => (
    {
        type: ACTION_TYPE_ADD_LIGHT_QA,
        payload: {
            answers:answers
        }
    }
);

export const ACTION_TYPE_ADD_LIGHT_QA_RESULT = 'ACTION_TYPE_ADD_LIGHT_QA_RESULT';
export const addLightQAResult = (res) => (
    {
        type: ACTION_TYPE_ADD_LIGHT_QA_RESULT,
        payload: {
            res:res
        }
    }
);

//-------- release light
export const ACTION_TYPE_RELEASE_LIGHTS = 'ACTION_TYPE_RELEASE_LIGHTS';
export const releaseLights = () => (
    {
        type: ACTION_TYPE_RELEASE_LIGHTS,
        payload: {

        }
    }
);

export const ACTION_TYPE_RELEASE_LIGHTS_RESULT = 'ACTION_TYPE_RELEASE_LIGHTS_RESULT';
export const releaseLightsResult = (lights) => (
    {
        type: ACTION_TYPE_RELEASE_LIGHTS_RESULT,
        payload: {
            lights:lights
        }
    }
);


export const ACTION_TYPE_LIGHT_ERROR = 'ACTION_TYPE_LIGHT_ERROR';
export const lightError = (error, from) => (
    {
        type: ACTION_TYPE_LIGHT_ERROR,
        payload: {
            error:error,
            from:from
        }
    }
);



//------------- timer popup

export const ACTION_TYPE_SHOW_TIME_MODAL = 'ACTION_TYPE_SHOW_TIME_MODAL';
export const ACTION_TYPE_CLOSE_TIME_MODAL = 'ACTION_TYPE_CLOSE_TIME_MODAL';

export const showTimeModal = (data) => (
    {
        type: ACTION_TYPE_SHOW_TIME_MODAL,
        payload: {
            data
        }
    }
);

export const closeTimeModal = () => (
    {
        type: ACTION_TYPE_CLOSE_TIME_MODAL,
        payload: {

        }
    }
);

//----------work
export const ACTION_TYPE_SCAN_RESULT = 'ACTION_TYPE_SCAN_RESULT';
export const scanResult = (filename) => (
    {
        type: ACTION_TYPE_SCAN_RESULT,
        payload: {
            filename: filename
        }
    }
);
//------------------------- manual popup

export const ACTION_TYPE_SHOW_RICH_MODAL = 'ACTION_TYPE_SHOW_RICH_MODAL';
export const ACTION_TYPE_CLOSE_RICH_MODAL = 'ACTION_TYPE_CLOSE_RICH_MODAL';

export const showRichModal = (data) => (
    {
        type: ACTION_TYPE_SHOW_RICH_MODAL,
        payload: {
            data
        }
    }
);

export const closeRichModal = () => (
    {
        type: ACTION_TYPE_CLOSE_RICH_MODAL,
        payload: {

        }
    }
);



// WEBPACK FOOTER //
// ./src/actions/index.js